export const CREATE_PURCHASE_BILL_RETURNS = 'CREATE_PURCHASE_BILL_RETURNS';
export const GET_PURCHASE_BILL_RETURNS = 'GET_PURCHASE_BILL_RETURNS';
export const GET_PURCHASE_BILL_RETURNS_PAGE = 'GET_PURCHASE_BILL_RETURNS_PAGE';
export const PURCHASE_BILL_RETURNS_REQUEST = 'PURCHASE_BILL_RETURNS_REQUEST';
export const UPDATE_PURCHASE_BILL_RETURNS = 'UPDATE_PURCHASE_BILL_RETURNS';
export const DELETE_PURCHASE_BILL_RETURNS = 'DELETE_PURCHASE_BILL_RETURNS';
export const SET_PURCHASE_RETURN_ORDERS = 'SET_PURCHASE_RETURN_ORDERS';
export const PURCHASE_BILL_RETURNS_REQUEST_SUCCESS = 'PURCHASE_BILL_RETURNS_REQUEST_SUCCESS';
export const PURCHASE_BILL_RETURNS_REQUEST_FAILURE = 'PURCHASE_BILL_RETURNS_REQUEST_FAILURE';